module.exports = __webpack_public_path__ + "./images/2719bfd74a1bea4f8a09c723028b8861.webp";